import { render, staticRenderFns } from "./ScoreboardLayout.vue?vue&type=template&id=7717677e&scoped=true"
import script from "./ScoreboardLayout.vue?vue&type=script&lang=ts"
export * from "./ScoreboardLayout.vue?vue&type=script&lang=ts"
import style0 from "./ScoreboardLayout.vue?vue&type=style&index=0&id=7717677e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7717677e",
  null
  
)

export default component.exports